import { Params } from '@angular/router';
import { Device } from '../providers/device/device';

export enum UNIT {
  nanoseconds, // some queries return values in nanoseconds
  microseconds,
  milliseconds,
  seconds,
  minutes,
  hours,
  days,
  percentage,
  bitsPerSecond, // others in bitsPerSecond
  count // others in count format ( like 'k', 'M', 'B'... so on )
}

export enum IKpiName {
  CLIENT = 'eueclientscore',
  APP = 'eueapplicationscore',
  NETWORK = 'euenetworkscore',
  SERVER = 'eueserverscore',
  APP_DELAY_OUT = 'appdelayout',
  APP_DELAY_IN = 'appdelayin',
  NETWORK_DELAY = 'networkdelay'
}

export interface getSiteByIPRequest {
  ip: string;
  siteIds: number[];
}

// describes a field from NitroDB_combinedflow.json
export interface IDataModelField {
  id: string;
  type: string;
  title: string;
  direction?: 'in' | 'out' | 'both';
  source?: 'kpi';
  fieldName?: string;
  groupBy?: boolean;
  exclude?: boolean;
}

export interface ITriageItem {
  kpiName: IKpiName;
  dimensions: string;
  dimensionAppId?: number;
  dimensionAppName?: string;
  dimensionSiteId?: number;
  dimensionSiteName?: string;
  dimensionServerIp?: string;
}

export interface ITriageObject {
  isAnomaly: boolean;
  item: ITriageItem;
  label?: string;
  url?: {
    target?: string;
    navigation?: string[];
    queryParams?: Params;
  };
}

export interface ILocation {
  city: string;
  country: string;
  lat: number;
  lon: number;
  state: string;
}

export interface ISite {
  id: number;
  description: string;
  location: ILocation;
  locationname?: string;
  name: string;
  source: ISource;
  subnets: Array<ISubnet>;
  tags: Array<any>; // eslint-disable-line
  isDefault: boolean;
  deleted: boolean;
  devices?: Array<Device>;
  closed?: boolean;
  hidden?: boolean;
  status?: string;
  isRowClicked?: boolean;
  isMarkerClicked?: boolean;
}

export interface ISource {
  id: number;
  type: string;
}

export interface ISubnet {
  name: string;
  description: string;
  subnet: string;
}

export interface ICoordinate {
  lat: number;
  lon: number;
}

export interface IApexSiteSync {
  apexId: string;
  dbName: string;
  hostName: string;
  port: number;
  publication: string;
  isActive: boolean;
  id?: number;
}
